<template>
<div class="container-fluid">
	<img v-if="!data_loaded" class="center-me" src="/images/loading-color.svg">

	<div v-else class="row">
	    <div class="col-12">
	    	<div class="d-flex align-items-center">
				<h1 class="flex-grow-1">All Organizations</h1>
				<router-link
					v-if="perms.can_create_org || !perms.can_create_org"
					:to="{ name: 'orgs.create' }"
					v-tooltip.bottom="'Add Organzation'"
					class="btn btn-sm btn-ghost-primary text-gray-500 leading-none"
					data-test="addOrgButton">
					<i class="far fa-plus-circle text-xl"></i>
	        	</router-link>
			</div>
			<div class="card">
				<table v-if="orgs" class="table table-hover orgs-table">
					<thead>
						<th></th>
						<th>Name</th>
						<th>Client Members</th>
						<th>User Members</th>
						<th></th>
					</thead>

					<tr v-for="org in orgs">
						<td style="width:32px">
							<div class="rounded-circle circle-cropped avatar-md ml-2 bg-gray-100 text-center">
						    	<i class="fal fa-sitemap text-gray-500"></i>
						    </div>
						</td>	
						<td>
							<router-link :to="{ name: 'orgs.show', params: { id: org.id } }">{{ org.name }}</router-link>
						</td>
						<td>
							<div v-if="org.clients" v-for="client in org.clients" class="d-flex mb-2">
								<div class="rounded-circle avatar-xs circle-cropped  bg-gray-100 text-center mr-2">
						    		<img v-if="client.logo_url" :src="client.logo_url" class="img-fluid">
						    		<i v-else class="fal fa-hospital text-sm text-gray-500"></i>
								</div>
								<router-link :to="{ name: 'clients.show', params:{ id: client.id } }">{{ client.name }}</router-link>
							</div>
						</td>
						<td>
							<div v-if="org.users" v-for="user in org.users" class="d-flex mb-2">
								<div class="rounded-circle avatar-xs circle-cropped mr-2">
						    		<img :src="user.photo_url" class="img-fluid">
								</div>								
								<router-link :to="{ name: 'users.show', params:{ id: user.id } }">{{ user.display_name }}</router-link>
							</div>
						</td>						
						<td class="drop-down drop-down-show dropleft text-right">
                            <a href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="contextMenu"><i class="far fa-ellipsis-h text-xl"></i></a>
                            <div class="dropdown-menu py-0" aria-labelledby="physicianDropDown">
                                <router-link :to="{ name: 'orgs.show', params: { id: org.id } }" class="dropdown-item">View Organization</router-link>
                                <router-link v-if="org.can.update" :to="{ name: 'orgs.edit', params: { id: org.id } }" class="dropdown-item" data-test="editOrganizationLink">Edit Organization</router-link>
                                <span class="dropdown-item" @click="deleteOrg(org.id)">Delete Organization</span>
                            </div>
                        </td>
					</tr>
				</table>
				<p v-else>No Organizations found.</p>

			</div>
		</div>
	</div>
</div>
</template>

<script>
	import { mapState } from 'vuex';
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				data_loaded: false,
				orgs: null,
			}
		},

		created() {
			this.fetchOrgs();
		},

		activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Organizations', to: { name: 'orgs.index' } },
            ]);
            this.fetchOrgs();
		},

		methods: {
			deleteOrg(id) {
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will not be able to recover this organization. Clients and users will lose the organization.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete organization',
					cancelButtonText: 'Keep organization',
					animation: false,
                }).then((result) => {
                	if (result.value) {
                        axios.delete('/api/admin/orgs/' + id).then(() => {
                        	this.fetchOrgs();
                        })
                    }
                });
			},

			fetchOrgs() {
				axios.get('/api/admin/orgs').then(({data}) => {
					this.data_loaded = true;
					this.orgs = data;
				});
			}
		},

		computed: mapState(['perms'])
	}
</script>